import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading" }

import { Loading } from '@element-plus/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
    visible: { type: Boolean },
    title: {},
    hideIcon: { type: Boolean }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideIcon)
      ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 24,
          name: "loading1"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Loading))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, _toDisplayString(_ctx.title || '加载中...'), 1)
  ], 512)), [
    [_vShow, _ctx.visible]
  ])
}
}

})